import { useNavigate } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#030305' }}>
      <Navigation />
      <div className="grid-bg" style={{ paddingTop: '100px', minHeight: 'calc(100vh - 64px)' }}>
        <div style={{ maxWidth: '500px', margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
          <div className="animate-fadeIn">
            <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(255,68,68,0.1)', border: '2px solid rgba(255,68,68,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
              <XCircle size={40} color="rgba(255,68,68,0.7)" />
            </div>
            <h1 style={{ fontFamily: 'Rajdhani', fontSize: '28px', fontWeight: 700, color: 'rgba(255,255,255,0.8)', marginBottom: '16px' }}>
              Payment Cancelled
            </h1>
            <p style={{ fontFamily: 'Outfit', fontSize: '15px', color: 'rgba(255,255,255,0.5)', marginBottom: '32px', lineHeight: 1.7 }}>
              No worries! You can continue learning with free orbits or upgrade anytime.
            </p>

            <div className="flex flex-col gap-3">
              <button
                onClick={() => navigate('/learn')}
                data-testid="continue-free-btn"
                className="px-6 py-3 rounded-lg flex items-center gap-2 justify-center w-full"
                style={{ fontFamily: 'Rajdhani', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.08em', background: 'rgba(0,240,255,0.1)', border: '1px solid rgba(0,240,255,0.3)', color: '#00F0FF', cursor: 'pointer' }}
              >
                <ArrowLeft size={16} /> Continue with Free Lessons
              </button>
              <button
                onClick={() => navigate('/')}
                className="px-6 py-3 rounded-lg w-full"
                style={{ fontFamily: 'Rajdhani', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.08em', background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.5)', cursor: 'pointer' }}
              >
                Return Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
